import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomTemplateWorkflowComponent } from './custom-template-workflow.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MwcButtonModule } from 'mwc/button';
import { MwcIconModule } from 'mwc/icon';
import { MwcFormModule } from 'mwc/form';
import { MwcInputModule } from 'mwc/input';
import { MwcTabsModule } from 'mwc/tabs';
import { MwcDividerModule } from 'mwc/divider';
import { MwcSelectModule } from 'mwc/select';
import { MwcTableModule } from 'mwc/table';
import { MwcTagModule } from 'mwc/tag';
import { MwcDropDownModule } from 'mwc/dropdown';
import { MwcCardModule } from 'mwc/card';
import { MwcGridModule } from 'mwc/grid';
import { MwcToolTipModule } from 'mwc/tooltip';
import { MwcNoAnimationModule } from 'mwc/core/no-animation';
import { MwcProgressModule } from 'mwc/progress';
import { MwcNotificationModule } from 'mwc/notification';
import { MwcUploadModule } from 'mwc/upload';
import { MwcCheckboxModule } from 'mwc/checkbox';
import { CustomTemplateWorkflowTabsetComponent } from './custom-template-workflow-tabset.component';
import { MwcTypographyModule } from 'mwc/typography';
import { MwcModalModule } from 'mwc/modal';
import { MwcAlertModule } from 'mwc/alert';
import { MwcSpinModule } from 'mwc/spin';

@NgModule({
  declarations: [
    CustomTemplateWorkflowComponent,
    CustomTemplateWorkflowTabsetComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MwcButtonModule,
    MwcIconModule,
    MwcFormModule,
    MwcInputModule,
    MwcTabsModule,
    MwcDividerModule,
    MwcSelectModule,
    MwcTableModule,
    MwcTagModule,
    MwcDropDownModule,
    MwcCardModule,
    MwcGridModule,
    MwcToolTipModule,
    MwcNoAnimationModule,
    MwcProgressModule,
    MwcNotificationModule,
    MwcUploadModule,
    MwcCheckboxModule,
    MwcTypographyModule,
    MwcDropDownModule,
    MwcModalModule,
    MwcAlertModule,
    MwcSpinModule
  ],
  exports: [
    CustomTemplateWorkflowComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CustomTemplateWorkflowModule { }
